// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function repeater1_itemReady($item, itemData, index) {
	if (itemData.onLine) {
		$item('#image17').show();
	}
}